import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function GoogleButton({ label = "Continue with Google" }) {
  const [googleClientId, setGoogleClientId] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/auth/google/config")
      .then((r) => setGoogleClientId(r.data.enabled ? r.data.client_id : ""))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/callback";
    if (!googleClientId) {
      // No third-party broker fallback, Google sign-in only ever uses the dedicated
      // HiredToday Google OAuth client, so the consent screen is HiredToday-branded.
      toast.error("Google sign-in is unavailable right now, please use your email instead.");
      return;
    }
    const params = new URLSearchParams({
      client_id: googleClientId,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid email profile",
      access_type: "online",
      prompt: "select_account",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
  };
  return (
    <button type="button" onClick={start} disabled={!loaded} data-testid="google-signin-btn"
      className="w-full h-12 inline-flex items-center justify-center gap-3 border border-zinc-300 rounded-md text-sm font-semibold text-zinc-800 bg-white hover:bg-zinc-50 hover:border-zinc-400 transition-colors duration-200 disabled:opacity-60">
      <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 2.18 7.06l3.66-2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
      </svg>
      {label}
    </button>
  );
}
